// Properties icons
import application_icon from "@/assets/icons/device/application.svg";
import charging_icon from "@/assets/icons/device/charging.svg";
import check_icon from "@/assets/icons/device/check.svg";
import eye_icon from "@/assets/icons/device/eye.svg";
import shield_icon from "@/assets/icons/shield-check.svg";
import default_icon from "@/assets/icons/about-us/rocket-launch.svg";

/**
 * Returns an array of objects containing options for each product property,
 * including icon URLs, titles, and descriptions.
 * @param properties The properties of the product.
 * @returns An array of objects containing property options.
 */
export const getPropertyOptions = (properties: IProductProperties) => {
  const icons: { [key: string]: string } = {
    Battery: charging_icon,
    Weatherproof: check_icon,
    Concealable: eye_icon,
    Platform: application_icon,
    Warranty: shield_icon,
  };

  const propertiesArray = properties ? Object.entries(properties) : [];

  return propertiesArray.map(([key, value]) => ({
    iconUrl: icons[key] || default_icon,
    title: key,
    description: value,
  }));
};
